module.exports = __webpack_public_path__ + "static/media/ktm-01.4714baac.jpg";